module.exports = require("@wordpress/editor");